import React, { useState, useEffect } from "react";
import Moment from "react-moment";
import { Clock, ImageIcon } from "lucide-react";
import "./ViewMasterResource.css";
import {
  appserveraddr,
  dmscoreservicecontextname,
} from "../../../../Services/EndPoints";

const sectionTitleStyle = {
  fontSize: "12px",
  fontWeight: 700,
  color: "#94A3B8",
  textTransform: "uppercase",
  letterSpacing: "0.08em",
  borderBottom: "1px solid #EEF2F6",
  paddingBottom: "8px",
  marginBottom: "14px",
};

const labelStyle = {
  display: "block",
  fontSize: "12px",
  fontWeight: 700,
  color: "#2E6DA4",
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  marginBottom: "4px",
};

const valueStyle = {
  fontSize: "12px",
  fontWeight: 600,
  color: "#0F2D42",
  lineHeight: 1.5,
};

const fieldGridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
  gap: "18px",
};

const MasterResourceInfo = ({ resourceData }) => {
  const [image, setImage] = useState(null);
  const [imageLoading, setImageLoading] = useState(true);

  useEffect(() => {
    const fetchImage = async () => {
      if (!resourceData?.resource_image_name) {
        setImageLoading(false);
        return;
      }
      setImageLoading(true);
      try {
        const imageUrl = `${appserveraddr}/${dmscoreservicecontextname}/master_resource/get_resource_image/${resourceData.resource_image_name}`;
        const response = await fetch(imageUrl, {
          headers: { Authorization: "Bearer " + localStorage.getItem("auth_token") },
        });
        if (response.ok) {
          const blob = await response.blob();
          const reader = new FileReader();
          reader.onloadend = () => {
            setImage(reader.result);
            setImageLoading(false);
          };
          reader.readAsDataURL(blob);
        } else {
          setImageLoading(false);
        }
      } catch (error) {
        setImageLoading(false);
      }
    };
    fetchImage();
  }, [resourceData]);

  if (!resourceData) {
    return (
      <div className="mrv-page">
        <div className="mrv-card mrv-empty">No resource data available.</div>
      </div>
    );
  }

  return (
    <div className="mrv-page">
      <div className="mrv-card mrv-card-body" style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        {/* ── Basic Information ── */}
        <div>
          <div style={sectionTitleStyle}>Basic Information</div>
          <div style={fieldGridStyle}>
            <div>
              <label style={labelStyle}>Activity</label>
              <div style={valueStyle}>{resourceData.activity || "NA"}</div>
            </div>
            <div>
              <label style={labelStyle}>Category</label>
              <div style={valueStyle}>{resourceData.category || "NA"}</div>
            </div>
            <div>
              <label style={labelStyle}>Resource Name</label>
              <div style={valueStyle}>{resourceData.name || "NA"}</div>
            </div>
          </div>
        </div>

        {/* ── Details ── */}
        <div>
          <div style={sectionTitleStyle}>Details</div>
          <div style={fieldGridStyle}>
            <div>
              <label style={labelStyle}>Unit</label>
              <div style={valueStyle}>{resourceData.unit || "NA"}</div>
            </div>
            <div>
              <label style={labelStyle}>
                <Clock size={11} style={{ marginRight: "4px", verticalAlign: "-1px" }} />
                Created On
              </label>
              <div style={valueStyle}>
                {resourceData.created_on ? (
                  <Moment format="DD-MM-YYYY, hh:mm A">{resourceData.created_on}</Moment>
                ) : (
                  "NA"
                )}
              </div>
            </div>
            <div>
              <label style={labelStyle}>
                <Clock size={11} style={{ marginRight: "4px", verticalAlign: "-1px" }} />
                Updated On
              </label>
              <div style={valueStyle}>
                {resourceData.updated_on ? (
                  <Moment format="DD-MM-YYYY, hh:mm A">{resourceData.updated_on}</Moment>
                ) : (
                  "NA"
                )}
              </div>
            </div>
          </div>
        </div>

        {/* ── Resource Image ── */}
        <div>
          <div style={sectionTitleStyle}>
            <ImageIcon size={11} style={{ marginRight: "4px", verticalAlign: "-1px" }} />
            Resource Image
          </div>
          <div className="mrv-image-box">
            {imageLoading ? (
              <span style={valueStyle}>Loading...</span>
            ) : image ? (
              <img src={image} alt={resourceData.name} className="mrv-image" />
            ) : (
              <span style={valueStyle}>NA</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MasterResourceInfo;
